import { FC } from 'react';
import { BoxProps, FormLabel, Textarea, Skeleton } from '@chakra-ui/react';
import { Field } from 'formik';
const StyledTextArea = ({
  field,
  ...props
}) => {
  return <Textarea width="100%" borderRadius={16} borderWidth="1.5px" borderColor="cloud.300" backgroundColor="transparent" resize="none" {...field} {...props} data-sentry-element="Textarea" data-sentry-component="StyledTextArea" data-sentry-source-file="CbFormikTextAreaField.tsx" />;
};
export interface CbFormikTextAreaFieldProps extends BoxProps {
  isLoading?: boolean;
  isDisabled?: boolean;
  title: string;
  id: string;
  placeholder?: string;
}
export const CbFormikTextAreaField: FC<CbFormikTextAreaFieldProps> = ({
  isLoading,
  isDisabled,
  title,
  id,
  placeholder,
  ...props
}) => {
  if (isLoading) {
    return <Skeleton height="100px" marginY={3} />;
  }
  return <>
      <FormLabel htmlFor={id} data-sentry-element="FormLabel" data-sentry-source-file="CbFormikTextAreaField.tsx">{title}</FormLabel>
      <Field id={id} isDisabled={isDisabled} name={id} placeholder={placeholder} component={StyledTextArea} borderRadius={16} _focus={{
      borderColor: 'chonky.500',
      borderWidth: '2px'
    }} _hover={{
      borderColor: 'cloud.400'
    }} {...props} data-sentry-element="Field" data-sentry-source-file="CbFormikTextAreaField.tsx" />
    </>;
};